import { getResourceUsage } from '@wix/ambassador-cloud-resourceusage-v1-resource-usage/http'
import type { ResourceUsage } from '@wix/ambassador-cloud-resourceusage-v1-resource-usage/types'
import type { HttpClient } from '@wix/http-client'

export const formatPremiumLimits = ({
  collectionCountLimit,
  totalItemCountLimit,
}: ResourceUsage) => {
  return {
    collectionCountLimit: collectionCountLimit ? collectionCountLimit : 0,
    itemCountLimit: totalItemCountLimit ? Number(totalItemCountLimit) : 0,
  }
}

export const getPremiumLimits = async (httpClient: HttpClient) => {
  const fields = ['collectionCountLimit', 'totalItemCountLimit']

  const {
    data: { resourceUsage },
  } = await httpClient.request(getResourceUsage({ fields }))

  return resourceUsage ? formatPremiumLimits(resourceUsage) : undefined
}
